export default __webpack_public_path__ + "static/media/o.dd64c166.png";